var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-list-item', _vm._g({
          attrs: {
            "ripple": "",
            "disabled": !_vm.workspacePermissionsEditable
          }
        }, on), [_c('v-list-item-icon', {
          staticClass: "mr-3"
        }, [_c('v-icon', [_vm._v("mdi-key")])], 1), _c('v-list-item-content', [_vm._v(" Permissions ")])], 1)];
      }
    }]),
    model: {
      value: _vm.permDialog,
      callback: function callback($$v) {
        _vm.permDialog = $$v;
      },
      expression: "permDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "perm-title"
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_vm._v(" Permissions for "), _c('strong', [_vm._v(_vm._s(_vm.workspace))])])], 1)], 1), _c('v-card', {
    staticClass: "global-perm grey darken-3 pa-5",
    attrs: {
      "dark": "",
      "flat": "",
      "tile": ""
    }
  }, [_c('v-row', [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "10"
    }
  }, [_c('v-autocomplete', {
    staticClass: "px-0",
    attrs: {
      "items": _vm.userSearchResults,
      "label": "Give permissions by email",
      "item-text": "listing",
      "chips": "",
      "deletable-chips": "",
      "full-width": "",
      "return-object": "",
      "multiple": "",
      "outlined": "",
      "hide-details": "",
      "hide-no-data": "",
      "hide-selected": "",
      "search-input": _vm.userSearchString
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.userSearchString = $event;
      },
      "update:search-input": [function ($event) {
        _vm.userSearchString = $event;
      }, _vm.throttledUserSearch],
      "change": function change($event) {
        _vm.userSearchString = null;
      },
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addSelectedUsers.apply(null, arguments);
      }
    },
    model: {
      value: _vm.newUserSelection,
      callback: function callback($$v) {
        _vm.newUserSelection = $$v;
      },
      expression: "newUserSelection"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "grey lighten-1",
            "dark": "",
            "fab": "",
            "outlined": ""
          },
          on: {
            "click": _vm.addSelectedUsers
          }
        }, on), [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v("Add selected")])])], 1), _c('v-spacer')], 1)], 1), _c('v-card', {
    staticClass: "pa-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', [_c('v-subheader', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    attrs: {
      "align-items": "center"
    }
  }, [_c('v-col', {
    staticClass: "user-list-heading pa-1",
    attrs: {
      "cols": "8"
    }
  }, [_vm._v(" Set individual permissions: ")]), _c('v-col', {
    staticClass: "user-list-all-select pa-0"
  }, [_c('v-select', {
    staticClass: "no-border ma-0 pa-0",
    attrs: {
      "items": _vm.assignableRoleListing,
      "hide-details": "",
      "dense": "",
      "placeholder": "change all to",
      "prepend-icon": "mdi-dots-horizontal"
    },
    on: {
      "input": function input($event) {
        _vm.setRoleForAllUsers(_vm.singularRoleToPlural($event));
      }
    }
  })], 1)], 1)], 1), _c('v-divider'), _vm._l(_vm.userPermissionsList, function (_ref3) {
    var user = _ref3.user,
        role = _ref3.role;
    return _c('v-list-item', {
      key: user.id,
      staticClass: "px-0"
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("mdi-account-circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "blue--text text--darken-2"
    }, [_vm._v(" " + _vm._s(user.email) + " ")])], 1), _c('v-list-item-action', {
      staticClass: "user-list-individual-select"
    }, [_c('v-select', {
      staticClass: "no-border ma-0 pa-0",
      attrs: {
        "items": role === 'owner' ? _vm.totalRoleListing : _vm.assignableRoleListing,
        "hide-details": "",
        "dense": "",
        "value": _vm.pluralRoleToSingular(role),
        "disabled": role === 'owner',
        "prepend-icon": "mdi-lock"
      },
      on: {
        "input": function input($event) {
          _vm.setRoleForUser(user, role, _vm.singularRoleToPlural($event));
        }
      }
    })], 1), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "disabled": role === 'owner'
      },
      on: {
        "click": function click($event) {
          return _vm.removeUserPermissions(user, role);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1);
  }), _c('v-divider')], 2), _c('v-card-actions', {
    staticClass: "pt-4"
  }, [_c('v-checkbox', {
    staticClass: "ma-0 mb-2",
    attrs: {
      "label": "Make this workspace public",
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.publicToggle,
      callback: function callback($$v) {
        _vm.publicToggle = $$v;
      },
      expression: "publicToggle"
    }
  }), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "top": "",
      "left": "",
      "open-on-hover": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on;
        return [_c('v-icon', _vm._g({
          staticClass: "ml-2 mb-1",
          attrs: {
            "small": ""
          }
        }, on), [_vm._v(" mdi-help-circle ")])];
      }
    }])
  }, [_c('v-card', {
    attrs: {
      "width": "20vw"
    }
  }, [_c('v-card-text', [_vm._v(" Public workspaces are readable by all users, even those who are not logged in. You can revoke this at any time by unchecking the box. ")])], 1)], 1), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "grey darken-2",
      "large": "",
      "text": ""
    },
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(" Cancel ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": "",
      "large": ""
    },
    on: {
      "click": _vm.setPermissions
    }
  }, [_vm._v(" Save Permissions ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }